var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-container',[_c('div',{staticClass:"h2 my-5 text-muted text-center"},[_vm._v(_vm._s(_vm.$t('Error 404')))]),_c('div',{staticClass:"h2 my-5 text-muted text-center"},[_vm._v(_vm._s(_vm.$t('Page not found')))])])}
var staticRenderFns = []

export { render, staticRenderFns }